import { Component, computed, inject, input, signal } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

import { PATH_FILTER_COMPOSER_STATE } from '../composer/path-filter-composer-state';
import { PhraseSegment } from './describe-filter';

/** Consecutive segments of one node, lit and hovered as one part of the phrase. */
interface PhrasePart {
  node: string | null;
  segments: PhraseSegment[];
}

let nextId = 0;

@Component({
  selector: 'app-path-filter-phrase',
  imports: [TranslatePipe],
  templateUrl: './path-filter-phrase.component.html',
  styles: `
    :host {
      display: block;
    }
  `
})
export class PathFilterPhraseComponent {
  segments = input.required<PhraseSegment[]>();
  /** The heading's translation key; null shows the sentence alone. */
  label = input<string | null>('features.data.path_filter.phrase.label');
  /** False drops the footer frame, for a sentence set inside a card. */
  framed = input(true);

  /** Outside a composer there are no rows to light, so hovering lights the part alone. */
  protected readonly hovered =
    inject(PATH_FILTER_COMPOSER_STATE, { optional: true })?.hovered ??
    signal<string | null>(null);
  protected readonly labelId = `path-filter-phrase-${nextId++}`;

  protected readonly parts = computed(() => {
    const parts: PhrasePart[] = [];
    for (const segment of this.segments()) {
      const last = parts.at(-1);
      if (last && last.node === segment.node) last.segments.push(segment);
      else parts.push({ node: segment.node, segments: [segment] });
    }
    return parts;
  });

  protected readonly ROLE_CLASSES: Record<PhraseSegment['role'], string> = {
    plain: '',
    field: 'text-text-primary font-semibold',
    value: 'text-accent-main font-mono text-[11.5px]',
    negation: 'text-danger font-semibold'
  };
}
